// Symbols of cryptocurrencies that can actually be sent/received on the platform
// Native coins of supported chains + all ERC20 tokens from token-contracts.ts

import { ERC20_TOKENS } from './token-contracts';

// Native coins of integrated chains
const NATIVE_SUPPORTED = new Set([
  'BTC',   // Bitcoin
  'ETH',   // Ethereum (EVM)
  'BNB',   // BSC (EVM)
  'SOL',   // Solana
  'AVAX',  // Avalanche C-Chain (EVM)
  'POL',   // Polygon (EVM)
  'ARB',   // Arbitrum (EVM)
  'TRX',   // Tron (TRC20)
  'LTC',   // Litecoin
]);

// Build full set: native + all ERC20 tokens
const ERC20_SYMBOLS = new Set(ERC20_TOKENS.map(t => t.symbol));

export const SUPPORTED_SYMBOLS = new Set([
  ...NATIVE_SUPPORTED,
  ...ERC20_SYMBOLS,
]);

export function isSupportedCrypto(symbol: string): boolean {
  return SUPPORTED_SYMBOLS.has(symbol.toUpperCase());
}
